import { useService as us } from 'bpmn-js-properties-panel';
import type { ServiceMap, ServiceMapKeys } from '../../../types/didi';

export const useService = us as <T extends ServiceMapKeys | string>(
    type: T,
    strict?: boolean
) => T extends ServiceMapKeys ? ServiceMap[T] : any;
